exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".react-select__option--is-disabled{opacity:0.5}.react-select__menu-list{font-size:90%;z-index:500}.react-select__group .react-select__group-heading{font-size:100%}.react-select__group .react-select__option{padding-left:1.5em}\n", ""]);

// exports
